var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0414 20.2976L24.4839 20.2976C25.5885 20.2976 26.4839 19.4022 26.4839 18.2976V3.46582C26.4839 2.36125 25.5885 1.46582 24.4839 1.46582H12.383C11.2784 1.46582 10.383 2.36125 10.383 3.46582V13.4411M7.10734 7.35363H3.48389C2.37932 7.35363 1.48389 8.24906 1.48389 9.35363V24.4658C1.48389 25.5704 2.37932 26.4658 3.48389 26.4658H14.0887C15.1932 26.4658 16.0887 25.5704 16.0887 24.4658V23.3817M8.90723 19.9915L18.2766 10.6221M18.4399 14.245V10.8164C18.4399 10.5403 18.216 10.3164 17.9399 10.3164H14.5703",
    stroke: "current",
    strokeWidth: 2.1,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.a52a09813ea5f323ca05cfe197149277.svg";
export { ForwardRef as ReactComponent };